import { useState } from 'react';
import { ColorSwatches } from './ColorSwatches';
import { Dialog } from './Dialog';

export interface TagDraft {
  name: string;
  color: string | null;
}

interface Props {
  /** A list tag is owned by one list; a global tag belongs to everything. */
  scope: 'list' | 'global';
  /** The owning list's name, shown so it is obvious which list is being edited. */
  listName?: string;
  initial?: Partial<TagDraft>;
  editing?: boolean;
  onSave: (draft: TagDraft) => void;
  onClose: () => void;
}

export function TagDialog({ scope, listName, initial = {}, editing = false, onSave, onClose }: Props) {
  const [name, setName] = useState(initial.name ?? '');
  const [color, setColor] = useState<string | null>(initial.color ?? null);
  const clean = name.trim().replace(/^[#@]/, '');

  const title = `${editing ? 'Edit' : 'New'} ${scope === 'list' ? 'list tag' : 'global tag'}`;
  const hint =
    scope === 'list'
      ? `Lives only inside ${listName ?? 'this list'}. Moving a note to another list drops it.`
      : 'Applies across every list, and survives a note being moved.';

  return (
    <Dialog
      title={title}
      hint={hint}
      submitLabel={editing ? 'Save' : 'Create'}
      submitDisabled={clean.length === 0}
      onSubmit={() => onSave({ name: clean, color })}
      onClose={onClose}
    >
      <label className="dlg-field">
        <span className="dlg-field__label">Name</span>
        <input
          className="dlg-field__input"
          value={name}
          autoFocus
          spellCheck={false}
          placeholder={scope === 'list' ? 'Invoices' : 'urgent'}
          onChange={(e) => setName(e.target.value)}
        />
      </label>

      <div className="dlg-field">
        <span className="dlg-field__label">Colour</span>
        <ColorSwatches value={color} onChange={setColor} />
      </div>
    </Dialog>
  );
}
